import { Injectable } from '@angular/core';

@Injectable()
export class BookService {

    private _jobRequest: any;
    private _location: any;
    private _optimized: any;
    private _preselectedSku: any;
    private _preselectedServices: any;
    private _quote: any;
    private _rightNow = false;
    private _selectedServices: any;
    private _selectedVehicle: any;
    private _vehicleData: any;
    private _serviceNotInList = false;
    private _approvalRequired = false;
    private _extraParams: any;

    static getPreselectedServicesFromUrlParams(productIdParam: string[] | string): {productId: number}[] {
        let preselectedServices;
        if (Array.isArray(productIdParam)) {
            preselectedServices = productIdParam.map(pId => ({productId: parseInt(pId)}));
        } else {
            preselectedServices = [{productId: parseInt(productIdParam)}];
        }
        return preselectedServices;
    }

    get jobRequest(): any {
        return this._jobRequest;
    }

    set jobRequest(value: any) {
        this._jobRequest = value;
    }

    get location(): any {
        return this._location;
    }

    set location(value: any) {
        this._location = value;
    }

    get optimized(): any {
        return this._optimized;
    }

    set optimized(value: any) {
        this._optimized = value;
    }

    get preSelectedSku(): any {
        return this._preselectedSku;
    }

    set preSelectedSku(value: any) {
        this._preselectedSku = value;
    }

    get preselectedServices(): any {
        return this._preselectedServices;
    }

    set preselectedServices(value: any) {
        this._preselectedServices = value;
    }

    get quote(): any {
        return this._quote;
    }

    set quote(value: any) {
        this._quote = value;
    }

    get rightNow(): boolean {
        return this._rightNow;
    }

    set rightNow(value: boolean) {
        this._rightNow = value;
    }

    get selectedServices(): any {
        return this._selectedServices;
    }

    set selectedServices(value: any) {
        this._selectedServices = value;
    }

    get selectedVehicle(): any {
        return this._selectedVehicle;
    }

    set selectedVehicle(value: any) {
        this._selectedVehicle = value;
    }

    get vehicleData(): any {
        return this._vehicleData;
    }

    set vehicleData(value: any) {
        this._vehicleData = value;
    }

    get serviceNotInList(): boolean {
        return this._serviceNotInList;
    }

    set serviceNotInList(value: boolean) {
        this._serviceNotInList = value;
    }

    get approvalRequired(): boolean {
        return this._approvalRequired;
    }

    set approvalRequired(value: boolean) {
        this._approvalRequired = value;
    }

    /**
     * this is extra data needed for services like lemon squad used car inspection for which we don't have specific fields in the database
     */
    get extraParams(): any {
        return this._extraParams;
    }

    set extraParams(value: any) {
        this._extraParams = value;
    }

    // helper method for returning an array of productIds
    public getPreselectedServiceProductIds(): number[] {
        return this.preselectedServices.map((s: {productId: number}) => s.productId);
    }

    public resetEverything() {
        this._jobRequest = null;
        this._location = null;
        this._optimized = null;
        this._preselectedServices = null;
        this._quote = null;
        this._rightNow = false;
        this._selectedServices = null;
        this._selectedVehicle = null;
        this._vehicleData = null;
        this._serviceNotInList = false;
        this._approvalRequired = false;
        this._extraParams = null;

    } // resetEverything()

}
